import { take } from 'rxjs';

import type { Observable } from 'rxjs';

export const warnup = (observable: Observable<unknown>): void => {
  observable.pipe(take(1)).subscribe();
};
